import { API_URL } from "../config";

export async function subirArchivo(file) {
  const token = localStorage.getItem("token");
  const formData = new FormData();
  formData.append("archivo", file);

  const res = await fetch(`${API_URL}/api/uploads`, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: formData,
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || "Error al subir el archivo.");
  }
  return data.nombre_archivo;
}

export function urlArchivo(nombreArchivo) {
  return `${API_URL}/api/uploads/archivos/${nombreArchivo}`;
}

// Los archivos son privados: se piden con la sesión iniciada y se abren en una pestaña nueva.
// (La pestaña se abre primero, en el clic, para que el navegador no la bloquee.)
export async function abrirArchivoSeguro(evento, nombreArchivo) {
  if (evento && evento.preventDefault) evento.preventDefault();
  const ventana = window.open("", "_blank");
  try {
    const token = localStorage.getItem("token");
    const res = await fetch(urlArchivo(nombreArchivo), {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.message || "No se pudo abrir el archivo.");
    }
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    if (ventana) ventana.location.href = url;
    else window.open(url, "_blank");
  } catch (err) {
    if (ventana) ventana.close();
    window.alert(err.message || "No se pudo abrir el archivo.");
  }
}
